import React from 'react'
import { initLanding } from "@common-hooks/init-landing"
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { QueryClient, QueryClientProvider } from 'react-query'

import { getPathForRouter } from "@common-helpers/get-rout-path"

import axios from "axios";

import Pages from './pages'

import "@common-css/index.css";
import "@common-css/main.css";

const queryClient = new QueryClient()

function App() {

  const stripe = (async () => {
    const key = await fetchPublishableKey();
    return loadStripe(key, { locale: 'en' });
  })();

  async function fetchPublishableKey() {
    const response = await axios.post('/stripe-get-key')
    const key = response.data.key
    return key
  }

  const landUrl = '/landing/29',
    getPath = getPathForRouter(landUrl),
    shouldChangeUrl = true

  localStorage.setItem('lang', 'eng');
  localStorage.setItem('landing-url', landUrl);

  initLanding()

  return (
    <Elements stripe={stripe}>

      <div className="App">
        <div className="window">
          <QueryClientProvider client={queryClient}>
            <Pages {...{ shouldChangeUrl, getPath }} />
          </QueryClientProvider>
        </div>
      </div>

    </Elements>
  );
}

export default App;
